export default __webpack_public_path__ + "static/media/trailer.e58e12d8.svg";